<template>
  <v-app>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{ text }}
      <v-btn class="primary--text" text @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <!-- <v-app-bar app color="white">
      <v-toolbar-title v-if="$store.state.currentOrg.orderPageLogo">
        <img
       style="max-height: 50px"
          align="center"
          justify="center"
          contain
          :src="$store.state.currentOrg.orderPageLogo"
        />
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <img
        style="max-height: 50px"
          align="center"
          justify="center"
          contain
          :src="$store.state.currentOrg.logo"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar> -->
    <v-content style="margin:0; padding:0">
      <router-view
      style="margin:0; padding:0"
        v-if="
          $route.name == 'FTTHApplication' ||
          $route.name == 'Tickets' ||
          $route.name == 'OrganisationApplication'||
          $route.name == 'PaymentSuccess'||
          $route.name == 'PaymentFailure'
        "
      ></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Api from "@/services/Api.js";
// import ftthApp from "./components/FTTHApplication.vue";

export default {
  name: "App",
  // components: {
  //   ftthapp: ftthApp,
  // },
  mounted(){
     this.$vuetify.theme.themes.light.primary = this.$store.state.currentOrg.orderPrimaryColour?this.$store.state.currentOrg.orderPrimaryColour:this.$store.state.currentOrg.primaryColour
this.$vuetify.theme.themes.light.secondary = this.$store.state.currentOrg.orderSecondaryColour?this.$store.state.currentOrg.orderSecondaryColour:this.$store.state.currentOrg.secondaryColour

  },
  created() {
    this.$store.dispatch("setToken", null);
    this.$store.dispatch("setUser", null);
    this.$store.dispatch("setIsUserLoggedIn", false);
    this.$vuetify.theme.themes.light.primary = this.$store.state.currentOrg.orderPrimaryColour?this.$store.state.currentOrg.orderPrimaryColour:this.$store.state.currentOrg.primaryColour
this.$vuetify.theme.themes.light.secondary = this.$store.state.currentOrg.orderSecondaryColour?this.$store.state.currentOrg.orderSecondaryColour:this.$store.state.currentOrg.secondaryColour
    
    // Light theme

  },
  data() {
    return {
      logo: null,
      text: "",
      snackbar: false,
      y: "top",
      show1: false,
      error: null,
      passwordError: false,
      emailAddress: "",
      password: "",
      errorMessage: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },
  methods: {
    async login() {
      this.passwordError = false;
      Api()
        .post("/login", {
          emailAddress: this.emailAddress,
          password: this.password,
        })
        .then((response) => {
          if (
            response.status === 403 ||
            response.status === 401 ||
            response.status === 500
          ) {
            this.errorMessage = true;
            this.snackbar = true;
            this.text = "Login Failed";
          }
          this.$store.dispatch("setUser", response.data.user);
          this.$store.dispatch("setIsUserLoggedIn", true);

        })
        .catch((err) => {
          this.passwordError = true;
          this.snackbar = true;
          this.text = "Invalid Email/Password Combination";
        });
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsUserLoggedIn", false);
      this.emailAddress = "";
      this.password = "";
    },
  },
};
</script>
<style>

</style>
